
















































































































































import { Vue, Component, Prop, PropSync, Watch } from 'vue-property-decorator';
import { router, routes } from '../router';
import { RouteConfig } from 'vue-router';
import Snackbar from '@/components/shared/Snackbar.vue';
import IAuthentication from '@/store/models/IAuthentication';
import IRolePermission from '@/store/models/IRolePermission';
import { SnotifyService } from 'vue-snotify/SnotifyService';
import IUserNotification from '@/store/models/IUserNotification';
import UserNotificationApi from '@/store/api/UserNotificationsApi';
import CompanyLicensesApi from '@/store/api/CompaniesLicensesApi';
import ICompaniesLicence from '@/store/models/ICompaniesLicence';
import SettingsCompanyApi from '@/store/api/SettingsCompanyApi';
import { SettingsCompany } from './shared/SettingsCompany';
import { EMPTY_GUID } from '@/config/constants';

@Component({
    components: {
        Snackbar
    }
})
export default class Sidebar extends Vue {
    linksTop: RouteConfig[] = [];
    userNotificationList: IUserNotification[] = [];
    notificationNotified: IUserNotification[] = [];
    userNotificationApi: UserNotificationApi;
    companyLicensesApi: CompanyLicensesApi;
    settingsCompanyApi: SettingsCompanyApi;

    companyId: string = "";
    userId: string = "";
    permissions : IRolePermission[] = [];
    isCustomer : boolean = false;
    hasPermissionsPlanning: boolean = false;
    hasPermissionsSettings: boolean = false;
    hasPermissionsDashboard: boolean = false;
    hasPermissionsCustomerDashboard: boolean = false;
    licenceExpiryDate: Date | null = null;
    
    constructor() {
        super();
        this.userNotificationApi = new UserNotificationApi();
        this.companyLicensesApi = new CompanyLicensesApi();
        this.settingsCompanyApi = new SettingsCompanyApi("Dashboard");
    }

    mounted() {
        this.loadPermissions();
    }

    async loadPermissions() {
        await this.initialize();
        if (!this.isCustomer) {
            this.hasPermissionsPlanning = await this.hasPermissionsFor("Planning");
            this.hasPermissionsDashboard = await this.hasPermissionsFor("Dashboard");
            this.hasPermissionsSettings = await this.hasPermissionsFor("Settings");
        } else {
            this.hasPermissionsCustomerDashboard = await this.hasPermissionsFor("CustomerDashboard");
        }
    }

    async initialize() {
        if (Vue.prototype.$IsLogged) {
            this.linksTop = await this.getRoutes();
        }
    }

    get userName(): string {
        const userFromStorage = JSON.parse(sessionStorage.getItem('user') || '{}');
        return userFromStorage && userFromStorage.username ? userFromStorage.username : "";
    }

    async getRoutes() : Promise<RouteConfig[]> {
        let routesWithAccess : RouteConfig[] = [];
        const userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');

        this.companyId = userFromStorage.idCompany;
        this.userId = userFromStorage.id;
        this.isCustomer = userFromStorage.idCustomer !== EMPTY_GUID;

        let licencesForms: ICompaniesLicence[] = [];

        if (this.companyId && !this.isCustomer) {
            this.companyLicensesApi = new CompanyLicensesApi();
            licencesForms = await this.companyLicensesApi.GetLicenceByIdCompany(this.companyId);

            const settingsCompany = SettingsCompany.Settings.Licence;
            const setting = await this.settingsCompanyApi.getSettingCompanyId(this.companyId, settingsCompany);

            if (setting && setting.length > 0 && setting[0].value) {
                this.licenceExpiryDate = this.parseToDate(setting[0].value);
            } else {
                this.licenceExpiryDate = null;
            }
        }

        routes.forEach((r: any) => {
            const rolePermission = userFromStorage.rolePermissions.find(p => p.formName === r.name);
            if (rolePermission && rolePermission.isAccesible) {
                const hasLicense = licencesForms.some(license => license.formName === r.name);
                if (!hasLicense) {
                    routesWithAccess.push(r);
                }
            }
        });

        return routesWithAccess;
    }

    async hasPermissionsFor(moduleName: string): Promise<boolean> {
        if (!this.companyId) return false;

        this.companyLicensesApi = new CompanyLicensesApi();
        const licencesForms = await this.companyLicensesApi.GetLicenceByIdCompany(this.companyId);
        
        const userFromStorage: IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        const hasLicense = licencesForms.some(license => license.formName.toLowerCase() === moduleName.toLowerCase());
        const hasAccess = userFromStorage.rolePermissions.some(p => p.formName.toLowerCase() === moduleName.toLowerCase() && p.isAccesible);
        return hasAccess && hasLicense;
    }

    GoToCustomerDashboard() {
        this.$router.push({ name: 'CustomerDashboard' }).catch(() => {});
    }

    GoToPlanning() {
        this.$router.push({ name: 'Planning' }).catch(() => {});
    }

    GoToDashboard() {
        this.$router.push({ name: 'Dashboard' }).catch(() => {});
    }

    GoToSetting() {
        this.$router.push({ name: 'Settings' }).catch(() => {});
    }

    logoff() {
        sessionStorage.clear();
        Vue.prototype.$IsLogged = false;
        this.$router.push({ name: 'Login' }).catch(() => {});
    }

    get numberNotifications() {
        return this.notificationNotified.length;
    }

    created() {
        this.getNotifications();
        setInterval(() => this.getNotifications(), 90000);
    }

    async getNotifications() {
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.userId = userFromStorage.id;
        if (this.userId) {
            if (userFromStorage.idCustomer === EMPTY_GUID) {
                this.userNotificationList = await this.userNotificationApi.GetNotificationsByUserId(this.userId);
                this.displayNotifications();
                this.notificationNotified = await this.userNotificationApi.GetNotificationsNotifyByUserId(this.userId);
            }
        }
    }

    displayNotifications() {
        this.userNotificationList.forEach(async n => {
            this.$snotify.success(n.body);
            await this.userNotificationApi.UpdateNotificationToNotify(n.id);
        });
    }

    get licenceExpiryText(): string {
        if (!this.licenceExpiryDate) return "";

        const diffDays = Math.ceil((this.licenceExpiryDate.getTime() - Date.now()) / 86400000);
        const dateStr = this.formatDate(this.licenceExpiryDate);

        if (diffDays < 0) return `License expired on ${dateStr}`;
        if (diffDays === 0) return `License expires today (${dateStr})`;
        return `License expires: ${dateStr}`;
    }

    get licenceChipColor(): string {
        if (!this.licenceExpiryDate) return "grey";

        const diffDays = Math.ceil((this.licenceExpiryDate.getTime() - Date.now()) / 86400000);

        if (diffDays <= 7) return "red";
        if (diffDays <= 30) return "orange";
        return "grey";
    }

    private formatDate(d: Date): string {
        // dd/mm/yyyy
        return new Intl.DateTimeFormat("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric"
        }).format(d);
    }

    private parseToDate(value: any): Date | null {
        if (!value) return null;

        // Si te llega epoch (ms)
        if (typeof value === "number") {
            const d = new Date(value);
            return isNaN(d.getTime()) ? null : d;
        }

        // Si te llega string: "2026-01-17", "17-01-2026", etc.
        if (typeof value === "string") {
            // ISO / Date.parse
            let d = new Date(value);
            if (!isNaN(d.getTime())) return d;

            // Intento dd-mm-yyyy
            const m = value.match(/^(\d{1,2})-(\d{1,2})-(\d{4})$/);
            if (m) {
                const day = parseInt(m[1], 10);
                const month = parseInt(m[2], 10) - 1;
                const year = parseInt(m[3], 10);
                d = new Date(year, month, day);
                return isNaN(d.getTime()) ? null : d;
            }
        }

        return null;
    }
}
